import React from 'react';
import {
  BuildingOffice2Icon,
  ChartBarIcon,
  DocumentTextIcon
} from '@heroicons/react/24/outline';

const LandlordToolkitComingSoon: React.FC = () => {
  const features = [
    {
      name: 'Manage Properties',
      description:
        'A unified dashboard to track your listings, applications, and tenant communications.',
      icon: BuildingOffice2Icon
    },
    {
      name: 'Rent Tracking & Payments',
      description:
        'Automate rent reminders and securely track payments for all your tenancies.',
      icon: DocumentTextIcon
    },
    {
      name: 'Performance Analytics',
      description:
        'Gain insights into your portfolio performance with key metrics and reports.',
      icon: ChartBarIcon
    }
  ];

  return (
    <>
      <div className="bg-white">
        <div className="mx-auto max-w-7xl py-16 px-4 sm:py-24 sm:px-6 lg:px-8">
          <div className="text-center">
            <h2 className="text-base font-semibold text-primary tracking-wide uppercase">
              Coming Soon
            </h2>
            <p className="mt-1 text-4xl font-bold tracking-tight text-gray-900 sm:text-5xl lg:text-6xl">
              The Ultimate Landlord Toolkit
            </p>
            <p className="mx-auto mt-5 max-w-xl text-xl text-gray-500">
              Streamline your property management, from listing to lease. We're
              building a powerful suite of tools to make being a landlord
              simpler and more profitable.
            </p>
          </div>

          <div className="mt-20">
            <dl className="space-y-10 md:grid md:grid-cols-3 md:gap-x-8 md:gap-y-10 md:space-y-0">
              {features.map((feature) => (
                <div key={feature.name} className="relative">
                  <dt>
                    <div className="absolute flex h-12 w-12 items-center justify-center rounded-md bg-primary text-white">
                      <feature.icon className="h-6 w-6" aria-hidden="true" />
                    </div>
                    <p className="ml-16 text-lg font-medium leading-6 text-gray-900">
                      {feature.name}
                    </p>
                  </dt>
                  <dd className="mt-2 ml-16 text-base text-gray-500">
                    {feature.description}
                  </dd>
                </div>
              ))}
            </dl>
          </div>
        </div>
      </div>
    </>
  );
};

export default LandlordToolkitComingSoon;
